<template>
    <div>
        <div class="position_center md-layout-item" style="width:520px;">
            <h4 class="font_lg font_bold">{{ $t("user.sendEmail.title") }}</h4>

            <div v-if="!isSend">
                <p>{{ $t("user.sendEmail.tip") }}</p>
                <form class="form-horizontal md-layout" action>
                    <div class="md-layout-item">
                        <md-field :class="[{ 'md-error': errors.has('email') }]">
                            <label>{{ $t("user.sendEmail.email") }}</label>
                            <md-input
                                v-model="email"
                                v-validate="modelValidations.email"
                                data-vv-name="email"
                                type="email"
                                required
                            ></md-input>
                        </md-field>
                    </div>
                </form>
            </div>
            <p v-else>{{ $t("user.sendEmail.sendTip") }}</p>

            <div v-if="!isSend">
                <md-button
                    class="opacity_5"
                    :class="{ 'md-primary': submitBtnStatus }"
                    @click="sendEmail"
                >{{ $t("user.sendEmail.send") }}
                </md-button>
            </div>

            <div style="margin-top:50px">
                <md-button
                    class="md-primary md-simple"
                    @click="goLogin('login')"
                >{{$t("SendEmail.backlogin")}}
                </md-button>
            </div>

        </div>
    </div>
</template>
<script>
import {userApi} from "@/common/api/userApi";

export default {
    data() {
        return {
            email: "",
            isSend: false,
            modelValidations: {
                email: {
                    required: true,
                    email: true
                }
            },
            touched: {
                email: false
            }
        };
    },
    methods: {
        sendEmail() {
            if (this.errors.has("email")) {
                return;
            }
            userApi
                .RequestLoginHelp(this.email)
                .then(res => {
                    this.isSend = true;
                })
                .catch(err => {
                    this.toast(err);
                });
        },
        goLogin(type) {
            this.$router.replace("/");
        }
    },
    computed: {
        submitBtnStatus() {
            let status = false;
            if (!this.errors.has("email") && this.email) {
                status = true;
            }
            return status;
        }
    },
    watch: {
        email() {
            this.touched.email = true;
        }
    }
};
</script>
